import React from "react";
import { PageHeader } from "./PageHeader";
import { DataBox } from "./DataBox";

export function ExportCreditCard() {
    return (
        <>
            <PageHeader />
            <DataBox />
        </>
    );
}

